import React from 'react';
import styled from 'styled-components';

const GameItem = ({game, onClick, showIcon, showTitle, className}) => {
    const _click = () => {
        onClick(game.id, game);
    };
    return (
        <Container onClick={_click} className={className}>
            <Image image={game.image}>{showIcon && <Icon />}</Image>

            {showTitle && <Text>{game.title}</Text>}
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    background-image: url(${props => props.img});
    background-size: cover;
    border-radius: 20px;
    cursor: pointer;
`;

const Image = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 16/9;
    border-radius: 20px;
    background-image: url(${props => props.image});
    background-size: cover;
    &:hover {
        transform: scale(1.05);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    }
    transition: transform 0.35s cubic-bezier(0.68, -0.51, 0.22, 1.68);
`;

const Text = styled.div`
    font-family: Mont;
    font-size: 14px;
    color: white;
    font-weight: 100;
    margin-top: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const Icon = styled.div`
    position: absolute;
    width: 50px;
    height: 50px;
    background-color: white;
    background-image: url(${require('../../assets/dkids/ic_game.png')});
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
    bottom: 9px;
    right: 9px;
`;

export default GameItem;
